import React, { Component } from 'react';
import {Layout,Menu, Input} from 'antd';
import {BrowserRouter as Router, Switch, Route, Link} from 'react-router-dom';
import styled from 'styled-components';
import logo from './logo.svg';
import search from './search.svg';
import './App.css';
import SearchItem from './SearchItem';
import IndexSearch from './components/IndexSearch';
import ArticleList from './components/ArticleList';

const {Header, Content, Footer }= Layout;
const {Search} = Input;

const MainContent = styled(Content)`
  width: 100%;
  max-width: 960px;
  padding-top: 24px;
  margin: auto;
`

const Logo = styled.img`
  height: 24px;
  width: 24px;
`

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      input: "",
    }
  }

  handleInputChange = (e) => {
    this.setState({
      input: e.target.value,
    })
  }

  handleSearchEvent = () => {
    console.log(`input: ${this.state.input}`);
  }

  handleKeyDown = (event) => {
    if(event.keyCode === 13) {
      this.handleSearchEvent()
    }
  }

  render() {
    const item = {
      name: '笑傲江湖',
      cover: 'http://wx.qlogo.cn/mmhead/Q3auHgzwzM4EOYw3p9pQDznBzXPxFSx5xwQk6LWKAkbhPhHNQNgsCw/0',
      key: '',
    }
    return (
      <Layout className="layout">

        <Header>
          <Link to="/" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
            <Logo src="https://ol0hvs2t3.qnssl.com/rss_icon.png" />
            <h3 lang="zh-Hans" style={{color: 'white', textAlign: 'center'}} >公众号订阅</h3>
          </Link>
        </Header>
        <MainContent>
          <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
            <Switch>
              <Route path="/" exact component={IndexSearch} />
              <Route path="/p/:biz" component={ArticleList} />
            </Switch>
          </div>
        </MainContent>
        <Footer className="zh-Hans" style={{ textAlign: 'center' }}>
          公众号订阅 ©2018 Created by Anreader.
          <a class="text-gray" style={{color: '#acb3c2'}} href="mailto:anreader.com@gmail.com">联系我们</a>
        </Footer>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js